export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#111111] py-16 px-6 md:px-16 lg:px-24">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-8 h-8 flex items-center justify-center bg-[#C9A84C] rounded-sm">
              <i className="ri-building-2-line text-white text-sm"></i>
            </div>
            <div>
              <span className="font-barlow font-800 text-white text-sm tracking-wide leading-none block">QUIROZ</span>
              <span className="font-inter text-[#C9A84C] text-[10px] tracking-widest leading-none block">CONSTRUCTION CLEANING, LLC</span>
            </div>
          </div>
          <p className="font-inter text-white/40 text-sm leading-relaxed max-w-xs mb-4">
            Professional post-construction cleaning and commercial cleaning services in Las Vegas, Nevada. Trusted by contractors and builders.
          </p>
          <a
            href="tel:+17022494799"
            className="inline-flex items-center gap-2 text-[#C9A84C] hover:text-[#E8C96A] font-barlow font-700 text-base tracking-wide transition-colors duration-200 cursor-pointer mb-6"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-[#C9A84C] text-base"></i>
            </div>
            (702) 249-4799
          </a>
          <div className="flex gap-3">
            {['ri-google-fill','ri-facebook-circle-line','ri-instagram-line'].map((icon) => (
              <div key={icon} className="w-8 h-8 flex items-center justify-center border border-white/15 rounded-sm cursor-pointer hover:border-[#C9A84C]/50 transition-colors">
                <i className={`${icon} text-white/50 text-sm`}></i>
              </div>
            ))}
          </div>
        </div>
        <div>
          <div className="font-barlow font-700 text-white text-sm tracking-wide mb-5 uppercase">Services</div>
          <div className="flex flex-col gap-3">
            {['Post-Construction Cleaning','Final Cleaning','Rough Cleaning','Commercial Cleaning','Debris Removal'].map((s) => (
              <span key={s} className="font-inter text-white/40 text-sm cursor-pointer hover:text-[#C9A84C] transition-colors" onClick={() => scrollTo('services')}>{s}</span>
            ))}
          </div>
        </div>
        <div>
          <div className="font-barlow font-700 text-white text-sm tracking-wide mb-5 uppercase">Company</div>
          <div className="flex flex-col gap-3">
            {[{l:'About Us',id:'why-us'},{l:'Our Process',id:'process'},{l:'Service Areas',id:'services'},{l:'FAQ',id:'faq'},{l:'Get a Quote',id:'contact'}].map((item) => (
              <span key={item.l} className="font-inter text-white/40 text-sm cursor-pointer hover:text-[#C9A84C] transition-colors" onClick={() => scrollTo(item.id)}>{item.l}</span>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="font-inter text-white/25 text-xs">© 2026 Quiroz Construction Cleaning, LLC. All rights reserved. Las Vegas, Nevada.</p>
        <div className="flex items-center gap-2">
          <i className="ri-map-pin-line text-[#C9A84C] text-xs"></i>
          <span className="font-inter text-white/25 text-xs">Las Vegas, NV</span>
        </div>
      </div>
      <div className="mt-6 overflow-hidden">
        <div className="font-barlow-condensed font-900 text-white/4 text-[80px] md:text-[120px] leading-none tracking-tighter whitespace-nowrap select-none">QUIROZ CONSTRUCTION CLEANING</div>
      </div>
    </footer>
  );
}
